import { DialogBody } from "@blueprintjs/core";
import { useWrapup } from "../wrapupcontext";
import { WrapupModuleKillsData } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";
import getItemById from "@/src/util/getItemById";
import pluralize from "@/src/util/pluralize";
import styles from './wrapup.module.css';
import WrapupModuleAvatar, { WrapupUserAvatarSize } from "./avatar";

export default function WrapupModuleKillsContinuedComponent(): React.ReactNode {
    const { wrapupData } = useWrapup();

    const data = wrapupData.data.kills as WrapupModuleKillsData;
    const topKiller = data.killedByUserIds[0];
    const topKillerUserId = topKiller[0];
    const topKillerCount = topKiller[1];
    const topKillerUser = getItemById(wrapupData.users, topKillerUserId);

    return <DialogBody className={styles.dialogBody}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}>
            <h1>Kills Continued</h1>
            <h3>You died {pluralize(data.deathCount, 'time')}, but one person had your number...</h3>
            <WrapupModuleAvatar user={topKillerUser} />
            <h3>{topKillerUser.name} killed you {pluralize(topKillerCount, 'time')}</h3>
            <h3>Your top killers:</h3>
            <table>
                <thead>
                    <tr style={{ fontWeight: 'bold' }}>
                        <td></td>
                        <td>Name</td>
                        <td>Kills</td>
                    </tr>
                </thead>
                <tbody>
                    {
                        data.killedByUserIds.map(
                            (entry) => {
                                const userId = entry[0];
                                const kills = entry[1];
                                const user = getItemById(wrapupData.users, userId);

                                return <tr key={userId}>
                                    <td>
                                        <WrapupModuleAvatar user={user} size={WrapupUserAvatarSize.Small} />
                                    </td>
                                    <td>{user.name}</td>
                                    <td>{kills}</td>
                                </tr>
                            }
                        )
                    }
                </tbody>
            </table>
        </div>
    </DialogBody>
}
